import type { FaireProductEntity } from "../../entity_types/product";

export const p_8f8ghb8ac9: FaireProductEntity = {
  token: "p_8f8ghb8ac9",
  type: "product",
  name: "Aubree Beige",
  brandToken: "b_2kdwbu5pkb",
  brandName: "LONZA SHOES",
  imageUrl: "https://cdn.faire.com/fastly/b6dd66906f6ebb43e2e996c692894fd27279ca257460f0be93de3054d605a0bf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2176026d300c9a54ccb8585a2daf6dc3e127c42db4eea493719dfbebfeb6d92c.png",
    "https://cdn.faire.com/fastly/7f206486b1a95aa6b1482367f2710055f5d6023637f942aa6143c1080bc64740.png",
    "https://cdn.faire.com/fastly/66878f522dd6716eedd8bbbcef1c6fcdd53cb6b6237a5060fa4353260dc65efd.png",
    "https://cdn.faire.com/fastly/99dcd4b4d21ad5a79df62d45893e96b891ce2d27ddb8a5b3ef33060cdbdcd8f7.png"
  ],
  priceDollars: 82,
  description: "Heel height - 0.8in\n\nGenuine Suede/Wool\n\nLining - Genuine Wool\n\nConquer the cold without compromising on elegance. The Aubree Winter Boots are designed to keep your feet toasty, dry, and stylish through snowy commutes and frosty weekend getaways alike\n",
  tags: [],
  msrpDollars: 164,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:52.136Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
